import React from 'react';
import {
    TableContainer,
    TableRow,
    TableHeader,
    TableHeaderCell,
    TableBody,
    TableCell
} from './styles';

const Table = ({headers, data, prospectingAttach, prospectingFunction}) => {


    return (
        <TableContainer>
            <TableHeader>
                {<TableRow>
                    {headers.map((header, i) => (<TableHeaderCell size={header.size} key={i}>{header.title}</TableHeaderCell>))}
                </TableRow>}
            </TableHeader>
            <TableBody>
                {data.map((obj, i) => (
                    <TableRow key={i}>
                        {Object.keys(obj).map((key, index) => {
                           return key !== 'status' ?
                           prospectingAttach && key === 'description' && i === 0 ?
                            <TableCell columns={Object.keys(obj).length} key={index}>{obj[key]} <span onClick={prospectingFunction}>aquí</span></TableCell> :
                            <TableCell columns={Object.keys(obj).length} key={index}>{obj[key]}</TableCell> :
                            <TableCell color={obj[key].color} columns={Object.keys(obj).length} key={index}>{obj[key].text}</TableCell>
                        })}
                    </TableRow>
                ))}
            </TableBody>
        </TableContainer>
    )
}

export default Table;